import { render, staticRenderFns } from "./CareInsInvoice.vue?vue&type=template&id=1044a7cc&"
import script from "./CareInsInvoice.vue?vue&type=script&lang=ts&"
export * from "./CareInsInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports